import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import CancelModal from 'pages/bookings/show/actions/CancelModal';
import compose from 'recompose/compose';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { DeactivateIcon } from 'assets/materialIcons/materialIcons';
import { cancelBooking } from 'store/actions/bookings/cancelBookings';
import { connect } from 'react-redux';

const styles = {
    button: {
        display: 'inline-block',
        overflow: 'visible',
    },
};

class CancelBooking extends React.Component {
    constructor() {
        super();

        this.toggleCancelModal = this.toggleCancelModal.bind(this);

        this.state = {
            dialogOpen: false,
        };
    }

    toggleCancelModal() {
        this.setState((prevState) => {
            return {
                dialogOpen: !prevState.dialogOpen,
            };
        });
    }

    handleSubmit = () => {
        const {
            dispatchCancel,
            id,
        } = this.props;

        return dispatchCancel({
            id: id,
        });
    }

    render() {
        const {
            orderId,
            translate,
        } = this.props;

        const {
            dialogOpen,
        } = this.state;

        return (
            <div style={ { display: 'contents' } }>
                <Button
                    icon={ <DeactivateIcon color={ theme.palette.redOrange } style={ { transform: 'rotate(45deg)' } } /> }
                    onClick={ this.toggleCancelModal }
                    title={ translate('actions.cancel') }
                />

                <CancelModal
                    dialogTitle={ `${ translate('resources.orders.cancel.title') } #${ orderId }` }
                    label={ translate('actions.cancel') }
                    modalSubmit={ this.handleSubmit }
                    modal={ true }
                    overlayStyle={ {
                        backgroundColor: 'rgba(237, 236, 236, 0.6)',
                    } }
                    style={ styles.button }
                    closeDialog={ this.toggleCancelModal }
                    dialogStatus={ dialogOpen }
                    dialogDescription={ translate('resources.orders.cancel.description') }
                />
            </div>
        );
    }
}

CancelBooking.propTypes = {
    id: PropTypes.number.isRequired,
    dispatchCancel: PropTypes.func.isRequired,
    orderId: PropTypes.number.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCancel: (values) => {
            dispatch(cancelBooking(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(CancelBooking);



// WEBPACK FOOTER //
// ./src/pages/bookings/show/actions/CancelBooking.js